import { rest } from 'msw';
import { API_USER_ROUTE } from '../../global/constants/routes/apiConstants';

export const signupHandlers = [
  rest.post(API_USER_ROUTE, (req, res, ctx) => {
    return res(ctx.status(201));
  }),
];
